import * as React from "react";
import C from "classnames";
export const ModalFooter = (props) => {
    return (React.createElement("div", { className: C("modal-footer", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=ModalFooter.js.map